import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ddddb9f2")

_pushScopeId("data-v-ddddb9f2")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-box" }
const _hoisted_3 = { class: "dialog-select-item-text" }
const _hoisted_4 = { class: "dialog-select-item-text" }
const _hoisted_5 = { class: "dialog-select-item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", {
              class: "dialog-select-item",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteAction(...args)))
            }, [
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.folderDeleteText), 1)
            ]),
            _createVNode("div", {
              class: "dialog-select-item",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.renameAction(...args)))
            }, [
              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.folderRenameText), 1)
            ]),
            _createVNode("div", {
              class: "dialog-select-item",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelAction(...args))),
              style: {"border":"none"}
            }, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.cancelText), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showDialog]
        ])
      ]),
      _: 1
    })
  ]))
})